import { render } from "./OutcomeTable.vue?vue&type=template&id=5a597da8&ts=true"
import script from "./OutcomeTable.vue?vue&type=script&lang=ts"
export * from "./OutcomeTable.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__